// Function to initialize a single dual content slider
function initP7DualContentSlider(sliderBlock) {
    if (!sliderBlock || sliderBlock.classList.contains('p7-dual-slider-initialized')) {
        return;
    }

    const leftSliderEl = sliderBlock.querySelector('.p7-dual-left-slider');
    const rightSliderEl = sliderBlock.querySelector('.p7-dual-right-slider');

    if (typeof Swiper === 'undefined') {
        console.warn('Swiper not loaded yet, retrying...');
        setTimeout(() => initP7DualContentSlider(sliderBlock), 500);
        return;
    }

    // Initialize left slider (manual content slider with progress)
    let leftSwiper = null;
    if (leftSliderEl) {
        const leftWrapper = sliderBlock.querySelector('.p7-dual-left-slider-wrapper');
        const paginationCurrent = leftWrapper ? leftWrapper.querySelector('.p7-dual-slider-pagination-current') : null;
        const progressBarFill = leftWrapper ? leftWrapper.querySelector('.p7-dual-slider-progress-bar-fill') : null;
        const totalSlides = leftSliderEl.querySelectorAll('.swiper-slide').length;

        leftSwiper = new Swiper(leftSliderEl, {
            // Reference design is a "content area" that changes on next/prev.
            // Use a horizontal fade slider (no vertical snapping).
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 450,
            autoHeight: true,
            autoplay: false,
            loop: false,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            navigation: {
                nextEl: leftWrapper ? leftWrapper.querySelector('.swiper-button-next') : null,
                prevEl: leftWrapper ? leftWrapper.querySelector('.swiper-button-prev') : null,
            },
            // Keep the left slider strictly manual (no wheel scrolling).
            mousewheel: false,
            keyboard: {
                enabled: true,
            },
            observer: true,
            observeParents: true,
            watchOverflow: true,
            on: {
                slideChange: function () {
                    const currentIndex = this.activeIndex + 1;
                    // Update pagination indicator
                    if (paginationCurrent) {
                        const current = String(currentIndex).padStart(2, '0');
                        paginationCurrent.textContent = current;
                    }
                    // Update progress bar
                    if (progressBarFill && totalSlides > 0) {
                        const progress = (currentIndex / totalSlides) * 100;
                        progressBarFill.style.width = progress + '%';
                    }
                }
            }
        });

        // Initialize pagination and progress bar on load
        if (paginationCurrent) {
            paginationCurrent.textContent = '01';
        }
        if (progressBarFill && totalSlides > 0) {
            const progress = (1 / totalSlides) * 100;
            progressBarFill.style.width = progress + '%';
        }
    }

    // Initialize right slider (posts slider)
    let rightSwiper = null;

    if (rightSliderEl) {

        rightSwiper = new Swiper(rightSliderEl, {
            slidesPerView: 1.1,
            spaceBetween: 20,
            speed: 450,
            grabCursor: true,

            freeMode: {
                enabled: true,
                sticky: false,
                momentumBounce: false,
                momentumRatio: 0.9,
            },

            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },

            mousewheel: {
                forceToAxis: true,
            },

            keyboard: {
                enabled: true,
            },

            breakpoints: {
                640: {
                    slidesPerView: 1.3,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2.4,
                    spaceBetween: 22,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 26,
                },
                1200: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                },
            },

            observer: true,
            observeParents: true,
            watchOverflow: true,

            resistance: true,
            resistanceRatio: 0.85,

            on: {
                init: function () {
                    this.update();
                },

                touchEnd: function () {

                    const containerWidth = this.width;
                    const wrapperWidth = this.wrapperEl.scrollWidth;
                    const maxScroll = Math.max(0, wrapperWidth - containerWidth);

                    const currentTranslate = this.getTranslate();

                    if (currentTranslate > 0) {
                        this.setTranslate(0);
                    } else if (Math.abs(currentTranslate) > maxScroll) {
                        this.setTranslate(-maxScroll);
                    }
                }
            }
        });

    }

    // Store instances
    sliderBlock.classList.add('p7-dual-slider-initialized');
    sliderBlock.leftSwiperInstance = leftSwiper;
    sliderBlock.rightSwiperInstance = rightSwiper;
}

function initializeAllP7DualContentSliders() {
    const sliders = document.querySelectorAll('.p7-dual-content-slider-block:not(.p7-dual-slider-initialized)');
    sliders.forEach(initP7DualContentSlider);
}

document.addEventListener('DOMContentLoaded', function () {
    initializeAllP7DualContentSliders();

    setTimeout(initializeAllP7DualContentSliders, 1000);
});

if (typeof wp !== 'undefined') {
    let gutenbergTimeout;

    if (wp.data && wp.data.subscribe) {
        wp.data.subscribe(() => {
            clearTimeout(gutenbergTimeout);
            gutenbergTimeout = setTimeout(() => {
                document.querySelectorAll('.p7-dual-content-slider-block.p7-dual-slider-initialized').forEach(block => {
                    if (block.leftSwiperInstance) {
                        block.leftSwiperInstance.destroy(true, true);
                    }
                    if (block.rightSwiperInstance) {
                        block.rightSwiperInstance.destroy(true, true);
                    }
                    block.classList.remove('p7-dual-slider-initialized');
                });
                initializeAllP7DualContentSliders();
            }, 100);
        });
    }
}

if (window.frameElement && window.frameElement.classList.contains('is-resizable')) {
    const resizeObserver = new ResizeObserver(() => {
        setTimeout(initializeAllP7DualContentSliders, 50);
    });

    resizeObserver.observe(document.body);
}

if (typeof Swiper === 'undefined') {
    Object.defineProperty(window, 'Swiper', {
        set: function (value) {
            window._Swiper = value;
            if (value) {
                setTimeout(initializeAllP7DualContentSliders, 100);
            }
        },
        get: function () {
            return window._Swiper;
        }
    });
}

if (typeof window !== 'undefined') {
    window.p7DualContentSlider = {
        initSlider: initP7DualContentSlider,
        initAllSliders: initializeAllP7DualContentSliders,
        destroyAllSliders: function () {
            document.querySelectorAll('.p7-dual-content-slider-block.p7-dual-slider-initialized').forEach(block => {
                if (block.leftSwiperInstance) {
                    block.leftSwiperInstance.destroy(true, true);
                }
                if (block.rightSwiperInstance) {
                    block.rightSwiperInstance.destroy(true, true);
                }
                block.classList.remove('p7-dual-slider-initialized');
            });
        }
    };
}

